/**
 * 로그인 — 계정 잠금 안내 배너.
 * Figma「로그인 — 계정 잠금」(12679:5148) 빨간색 알림 박스.
 */
import {
  LOGIN_ACCOUNT_LOCKED_HINT,
  LOGIN_ACCOUNT_LOCKED_TITLE,
} from '@/shared/utils/loginAccountLock';
import { cn } from '@/shared/lib/utils';
import { TriangleAlert } from 'lucide-react';
import React from 'react';

type LoginAccountLockedAlertProps = {
  className?: string;
  title?: string;
  hint?: string;
};

export const LoginAccountLockedAlert: React.FC<
  LoginAccountLockedAlertProps
> = ({
  className,
  title = LOGIN_ACCOUNT_LOCKED_TITLE,
  hint = LOGIN_ACCOUNT_LOCKED_HINT,
}) => (
  <div
    role="alert"
    className={cn(
      'flex w-full items-start gap-2 rounded-8 bg-ruda-error-50 px-3.5 py-3 text-xs leading-normal text-ruda-error',
      className,
    )}
  >
    <TriangleAlert
      className="mt-0.5 h-3.5 w-3.5 shrink-0"
      aria-hidden
    />
    <div className="min-w-0 flex-1">
      <p>{title}</p>
      <p>{hint}</p>
    </div>
  </div>
);
